// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ops-page-wrapper {
  box-sizing: border-box;
  padding: 20px 24px 80px;
  background: #fff;
  min-height: 100vh;
  width: 100%;
}

.ops-page-section-title {
  font-size: 18px;
  font-weight: 700;
  color: #90a1b9 !important;
  letter-spacing: 0.02em;
  margin: 50px 0 14px 2px;
  text-transform: uppercase;
}

.ops-page-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  margin-bottom: 28px;
}

@media (max-width: 1024px) {
  .ops-page-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 768px) {
  .ops-page-grid {
    grid-template-columns: repeat(4, 1fr);
  }
  .ops-page-wrapper {
    padding: 16px 14px 80px;
  }
}

@media (max-width: 500px) {
  .ops-page-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.ops-page-card {
  background: #f8fafc80 !important;
  border-radius: 16px;
  /* border: 1px solid #e9ecf3; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  cursor: pointer;
  min-height: 108px;
  transition:
    box-shadow 0.15s ease,
    transform 0.12s ease;
  user-select: none;
  text-decoration: none !important;
}

.ops-page-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.09);
  transform: translateY(-2px);
}

.ops-page-card:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
}

.ops-page-card-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  border: 1.5px solid #f9f3f4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #62748e !important;
  background: #fff;
  flex-shrink: 0;
}

.ops-page-card-icon svg {
  width: 28px;
  height: 28px;
}

.ops-page-card-label {
  font-size: 14px;
  font-weight: 700;
  color: #45556c !important;
  text-align: center;
  line-height: 1.35;
  text-decoration: none !important;
}

/* Dark mode */
.ops-page-wrapper.dark {
  background: #1e2235;
}

.ops-page-wrapper.dark .ops-page-section-title {
  color: #9ca3af !important;
}

.ops-page-wrapper.dark .ops-page-card {
  background: #2a2f47 !important;
  border-color: #3a3f5a;
}

.ops-page-wrapper.dark .ops-page-card-icon {
  border-color: #4b5268;
  color: #e5e7eb !important;
  background: #2a2f47;
}

.ops-page-wrapper.dark .ops-page-card-icon svg {
  color: #e5e7eb !important;
}

.ops-page-wrapper.dark .ops-page-card-label {
  color: #e5e7eb !important;
}

/* ── Top Navbar ── */
.ops-page-top-navbar-section {
  width: 100%;
  /* border-bottom: 1px solid #e9ecf3; */
  margin-bottom: 4px;
}

.ops-page-navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 4px;
}

.ops-page-navbar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ops-page-navbar-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background: #4f46e5;
  color: #fff;
  flex-shrink: 0;
  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.3);
}

.ops-page-navbar-logo svg {
  width: 24px;
  height: 24px;
  color: #fff;
  stroke: #fff;
}

.ops-page-navbar-titles {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ops-page-navbar-app-name {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  margin: 0;
  line-height: 1.2;
}

.ops-page-navbar-subtitle {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #94a3b8;
}

.ops-page-navbar-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #64748b;
  transition:
    background 0.15s ease,
    color 0.15s ease;
  flex-shrink: 0;
}

.ops-page-navbar-close-btn:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.ops-page-navbar-close-btn:active {
  background: #e2e8f0;
}

.ops-page-navbar-close-btn svg {
  width: 24px;
  height: 24px;
}

/* Dark mode – navbar */
.ops-page-wrapper.dark .ops-page-top-navbar-section {
  /* border-bottom-color: #3a3f5a; */
}

.ops-page-wrapper.dark .ops-page-navbar-app-name {
  color: #f1f5f9;
}

.ops-page-wrapper.dark .ops-page-navbar-subtitle {
  color: #64748b;
}

.ops-page-wrapper.dark .ops-page-navbar-close-btn {
  color: #94a3b8;
}

.ops-page-wrapper.dark .ops-page-navbar-close-btn:hover {
  background: #2a2f47;
  color: #e5e7eb;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/OperationsMenuPage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB;;wBAEsB;EACtB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd;;oBAEkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".ops-page-wrapper {\n  box-sizing: border-box;\n  padding: 20px 24px 80px;\n  background: #fff;\n  min-height: 100vh;\n  width: 100%;\n}\n\n.ops-page-section-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #90a1b9 !important;\n  letter-spacing: 0.02em;\n  margin: 50px 0 14px 2px;\n  text-transform: uppercase;\n}\n\n.ops-page-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 12px;\n  margin-bottom: 28px;\n}\n\n@media (max-width: 1024px) {\n  .ops-page-grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .ops-page-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  .ops-page-wrapper {\n    padding: 16px 14px 80px;\n  }\n}\n\n@media (max-width: 500px) {\n  .ops-page-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.ops-page-card {\n  background: #f8fafc80 !important;\n  border-radius: 16px;\n  /* border: 1px solid #e9ecf3; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 20px;\n  cursor: pointer;\n  min-height: 108px;\n  transition:\n    box-shadow 0.15s ease,\n    transform 0.12s ease;\n  user-select: none;\n  text-decoration: none !important;\n}\n\n.ops-page-card:hover {\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.09);\n  transform: translateY(-2px);\n}\n\n.ops-page-card:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\n}\n\n.ops-page-card-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  border: 1.5px solid #f9f3f4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #62748e !important;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.ops-page-card-icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.ops-page-card-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #45556c !important;\n  text-align: center;\n  line-height: 1.35;\n  text-decoration: none !important;\n}\n\n/* Dark mode */\n.ops-page-wrapper.dark {\n  background: #1e2235;\n}\n\n.ops-page-wrapper.dark .ops-page-section-title {\n  color: #9ca3af !important;\n}\n\n.ops-page-wrapper.dark .ops-page-card {\n  background: #2a2f47 !important;\n  border-color: #3a3f5a;\n}\n\n.ops-page-wrapper.dark .ops-page-card-icon {\n  border-color: #4b5268;\n  color: #e5e7eb !important;\n  background: #2a2f47;\n}\n\n.ops-page-wrapper.dark .ops-page-card-icon svg {\n  color: #e5e7eb !important;\n}\n\n.ops-page-wrapper.dark .ops-page-card-label {\n  color: #e5e7eb !important;\n}\n\n/* ── Top Navbar ── */\n.ops-page-top-navbar-section {\n  width: 100%;\n  /* border-bottom: 1px solid #e9ecf3; */\n  margin-bottom: 4px;\n}\n\n.ops-page-navbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 4px;\n}\n\n.ops-page-navbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.ops-page-navbar-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 16px;\n  background: #4f46e5;\n  color: #fff;\n  flex-shrink: 0;\n  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.3);\n}\n\n.ops-page-navbar-logo svg {\n  width: 24px;\n  height: 24px;\n  color: #fff;\n  stroke: #fff;\n}\n\n.ops-page-navbar-titles {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ops-page-navbar-app-name {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.ops-page-navbar-subtitle {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: #94a3b8;\n}\n\n.ops-page-navbar-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #64748b;\n  transition:\n    background 0.15s ease,\n    color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.ops-page-navbar-close-btn:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.ops-page-navbar-close-btn:active {\n  background: #e2e8f0;\n}\n\n.ops-page-navbar-close-btn svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* Dark mode – navbar */\n.ops-page-wrapper.dark .ops-page-top-navbar-section {\n  /* border-bottom-color: #3a3f5a; */\n}\n\n.ops-page-wrapper.dark .ops-page-navbar-app-name {\n  color: #f1f5f9;\n}\n\n.ops-page-wrapper.dark .ops-page-navbar-subtitle {\n  color: #64748b;\n}\n\n.ops-page-wrapper.dark .ops-page-navbar-close-btn {\n  color: #94a3b8;\n}\n\n.ops-page-wrapper.dark .ops-page-navbar-close-btn:hover {\n  background: #2a2f47;\n  color: #e5e7eb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
